import React from "react";
import { Button } from "@packages/ui";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";

const VirComfirmDialog = ({
  open,
  title = "Vehicle Incident Report",
  handleClose,
  content,
  execute,
  loading,
  confirmText = "Ok",
  cancelText = "Cancel",
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <span style={{ color: "black", fontSize: "22px", fontFamily: "Ride" }}>{title}</span>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <span style={{ color: "black", fontSize: "18px", fontFamily: "Ride" }}>{content}</span>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={execute} disabled={loading} autoFocus>
          {loading ? <CircularProgress /> : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VirComfirmDialog;
